<template>
  <ul class="account-menu">
    <li>
      <router-link  to="/account">
        <monitor-icon title="Moje konto" />
        <span>Moje konto</span>
      </router-link>
    </li>
    <li v-if="user.level.id == 11">
        <span class="parent">
          <home-icon title="Adresy dostaw" />
          <span>Adresy dostaw</span>
        </span>
      <ul class="account-menu-child">
        <li><router-link  to="/account/addresses">Lista adresów</router-link></li>
        <!-- <li><router-link  to="/account/addresses/add">Nowy adres</router-link></li> -->
      </ul>
    </li>

    <li v-if="user.level.id == 11">
        <span class="parent">
          <account-multiple-icon title="Konta użytkowników"/>
          <span>Konta użytkowników</span>
        </span>
      <ul class="account-menu-child">
        <li><router-link  to="/account/users">Lista użytkowników</router-link></li>
        <li><router-link  to="/account/user">Nowy użytkownik</router-link></li>
      </ul>
    </li>
    <li>
      <router-link  to="/account/orders">
        <sale-icon title="Lista zamówień" />
        <span>Zamówienia</span>
      </router-link>
    </li>
    <li v-if="offerEnable">
      <router-link  to="/account/offers">
        <book-icon title="Lista ofert" />
        <span>Oferty</span>
      </router-link>
    </li>
    <li v-if="user.level.id == 11">
      <router-link  to="/account/invoices">
        <receipt-icon title="Lista faktur" />
        <span>Faktury</span>
      </router-link>
    </li>
    <li v-if="user.level.id == 11 && mpkEnable">
        <span class="parent">
          <bank-icon title="Budżety" />
          <span>Budżety</span>
        </span>
      <ul class="account-menu-child">
        <li><router-link  to="/account/budgets">Lista budżetów</router-link></li>
        <li><router-link  to="/account/budgets/add">Nowy budżet</router-link></li>
      </ul>
    </li>
    <li v-if="user.level.id == 11 && mpkEnable">
        <span class="parent">
          <finance-icon title="Miejsca powstawania kosztów" />
          <span>Miejsca powstawania kosztów</span>
        </span>
      <ul class="account-menu-child">
        <li><router-link  to="/account/mpks">Lista MPK</router-link></li>
        <li><router-link  to="/account/mpks/add">Nowy MPK</router-link></li>
      </ul>
    </li>
    <li>
      <router-link  to="/account/settings">
        <wrench-icon title="Ustawienia" />
        <span>Ustawienia</span>
      </router-link>
    </li>
  </ul>

</template>


<script>
    import { mapState } from 'vuex';
    import MonitorIcon from "vue-material-design-icons/Monitor.vue";
    import HomeIcon from "vue-material-design-icons/Home.vue";
    import AccountMultipleIcon from "vue-material-design-icons/AccountMultiple.vue";
    import SaleIcon from "vue-material-design-icons/Sale.vue";
    import BookIcon from "vue-material-design-icons/Book.vue";
    import ReceiptIcon from "vue-material-design-icons/Receipt.vue";
    import BankIcon from "vue-material-design-icons/Bank.vue";
    import FinanceIcon from "vue-material-design-icons/Finance.vue";
    import WrenchIcon from "vue-material-design-icons/Wrench.vue";


    export default {
        components: {
            WrenchIcon,
            FinanceIcon,
            BankIcon,
            BookIcon,
            ReceiptIcon,
            SaleIcon,
            AccountMultipleIcon,
            HomeIcon,
            MonitorIcon,
        },
        computed: {
            ...mapState({
                user: state => state.user.authorizedUser,
                mpkEnable: state => state.shop.settings.find(s => s.name == 'B2B_MPK_ENABLED') ? state.shop.settings.find(s => s.name == 'B2B_MPK_ENABLED') : 0
            }),
        },
        data() {
            return {
                offerEnable: false
            }
        },
        beforeMount() {
            this.offerEnable = this.$config.get('offer.enable');
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/AccountMenu.vue